export default __webpack_public_path__ + "images/25e67ac370eed47f6d7e699e7fee6ae6-success_list@2x.png";